import { Flex, message, Modal, Spin } from "antd";
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { CiCirclePlus } from "react-icons/ci";
import {
  base64ToFile,
  encodeBase64File,
} from "../../../../../utils/encodeBase64";
import { EyeOutlined, UploadOutlined } from "@ant-design/icons";
import AddInsuranceDetails from "./addInsuranceDetails";
import ProgInsuranceCCTable from "./progInsuranceCCTable";
import nodatafound from "../../../../../Assets/Icons/NoDataCard2.svg";
import AddChronicCondition from "./addNewRpmChronic";
import { useDispatch, useSelector } from "react-redux";
import { convertUTCDate } from "../../../../../utils/convertionFunc";
import { handleSetPatientRegistrationPayload } from "../../../../../Redux/actions/patientActions";
import deleteHoverIcon from "../../../../../Assets/Images/hoverdelete.svg";

function ProgramInsurance({
  currPageView,
  handleCancel,
  handleNext,
  handlePrevious,
  isRpmEnabled
}, ref) {
  const [consentOne, setConsentOne] = useState(null);
  const [consentTwo, setConsentTwo] = useState(null);
  const [consentThree, setConsentThree] = useState(null);
  const [ConsentFour, setConsentFour] = useState(null);
  const [viewDoc, setViewDoc] = useState("");
  const [pdfVisible, setpdfVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currLocalMappedChronics, setCurrLocalMappedChronics] = useState([]);
  const [currUploadedConsents, setCurrUploadedConsents] = useState([]);
  const { registrationPayload, selectedEditPatient } = useSelector(
    (state) => state.patients
  );
  const dispatch = useDispatch();
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    if (selectedEditPatient?.patientChronicConditionsList) {
      setCurrLocalMappedChronics(
        selectedEditPatient?.patientChronicConditionsList
      );
    }

    if (
      selectedEditPatient?.patientRegConsentDtlList &&
      selectedEditPatient?.patientRegConsentDtlList.length > 0
    ) {
      selectedEditPatient.patientRegConsentDtlList.forEach((item) => {
        const { consentCode, esignName } = item;
        // const fileName = `Consent_${consentCode}.pdf`;
        // const fileBlob = base64ToFile(esign, fileName, esignType);
        if (item.esignName) {
          switch (consentCode) {
            case "PROGRAM":
              setConsentOne(process.env.REACT_APP_IMAGE_URL + esignName);
              break;
            case "PATIENT_DATA":
              setConsentTwo(process.env.REACT_APP_IMAGE_URL + esignName);
              break;
            case "DEVICE_RESP":
              setConsentThree(process.env.REACT_APP_IMAGE_URL + esignName);
              break;
            case "PHYSICIAN_ORDER":
              setConsentFour(process.env.REACT_APP_IMAGE_URL + esignName);
              break;
            default:
              break;
          }
        }
      });

      if (!registrationPayload?.patientRegConsentDtlList) {
        dispatch(
          handleSetPatientRegistrationPayload({
            ...registrationPayload,
            patientRegConsentDtlList: selectedEditPatient.patientRegConsentDtlList,
          })
        );
      }
    }
  }, [selectedEditPatient]);

  useImperativeHandle(ref, () => ({
    collectValues: () => {
      if (!currLocalMappedChronics.length) return;
      const payload = {
          ...(selectedEditPatient ? selectedEditPatient : {}),
          ...registrationPayload,
          patientChronicConditionsList: currLocalMappedChronics,
      };
      dispatch(handleSetPatientRegistrationPayload(payload));
    }
  }));


  const changeHandler = async (file, e) => {
    if (file.type !== "application/pdf") {
      message.error("Please upload only PDF files");
      return;
    }
    const max_size = 10 * 1024 * 1024;

    if (file && file.size > max_size) {
      message.error("Pdf size should be less than or equal to 10 mb !!");
      return;
    }

    const base64Encoded = await encodeBase64File(file);

    const payload = {
      account_Id: loggedUser?.user?.account_Id,
      clinic_Id: loggedUser?.user?.clinic_Id,
      consentCode: e,
      consentName: "",
      createdBy: loggedUser?.user?.userId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      esign: base64Encoded,
      esignType: file.type.split("/")[1],
      modifiedBy: loggedUser?.user?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      otpConsent: "Y",
      status: 1,
    };

    if (selectedEditPatient) {
      payload.patientId = selectedEditPatient.patientId;
    }

    switch (e) {
      case "PROGRAM":
        payload.consentName = "OnProgram";
        setConsentOne(file);
        break;
      case "PATIENT_DATA":
        payload.consentName = "ToSharePatientData";
        setConsentTwo(file);
        break;
      case "DEVICE_RESP":
        payload.consentName = "OnDeviceResponsibility";
        setConsentThree(file);
        break;
      case "PHYSICIAN_ORDER":
        payload.consentName = "Physician Order";
        setConsentFour(file);
        break;
      default:
        break;
    }

    const currItemsInConsent =
      registrationPayload?.patientRegConsentDtlList
        ? [...registrationPayload.patientRegConsentDtlList]
        : selectedEditPatient?.patientRegConsentDtlList
        ? [...selectedEditPatient.patientRegConsentDtlList]
        : [];
    const updatedItems = currItemsInConsent.filter(
      (item) => item.consentCode !== e
    );
    updatedItems.push(payload);

    const pdfPayload = {
      ...registrationPayload,
      patientRegConsentDtlList: updatedItems,
    };

    dispatch(handleSetPatientRegistrationPayload(pdfPayload));
  };

  const showPdf = (e) => {
    let file;
    if (e === "PROGRAM") file = consentOne;
    if (e === "PATIENT_DATA") file = consentTwo;
    if (e === "DEVICE_RESP") file = consentThree;
    if (e === "PHYSICIAN_ORDER") file = ConsentFour;

    if (!file) return;

    if (typeof file === "string") {
      if (file.toLowerCase().endsWith(".pdf")) {
        setViewDoc(file);
        setpdfVisible(true);
      }
    } else if (file instanceof File && file.type === "application/pdf") {
      const fileURL = URL.createObjectURL(file);
      setViewDoc(fileURL);
      setpdfVisible(true);
    }
  };

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handlSetLocalMappedChronics = (mappingObj) => {
    setCurrLocalMappedChronics((prevState) => [...prevState, mappingObj]);
  };

  const handlePdfViewClose = () => {
    setpdfVisible(false);
  };

  const handleDelete = (e) => {
    if (e === "PROGRAM") setConsentOne(null);
    if (e === "PATIENT_DATA") setConsentTwo(null);
    if (e === "DEVICE_RESP") setConsentThree(null);
    if (e === "PHYSICIAN_ORDER") setConsentFour(null);

    const currItemsInConsent =
      registrationPayload?.patientRegConsentDtlList
        ? [...registrationPayload.patientRegConsentDtlList]
        : selectedEditPatient?.patientRegConsentDtlList
        ? [...selectedEditPatient.patientRegConsentDtlList]
        : [];

    const currItemsAfterDeletion = currItemsInConsent.filter(
      (item) => item.consentCode !== e
    );

    const pdfPayload = {
      ...registrationPayload,
      patientRegConsentDtlList: currItemsAfterDeletion,
    };

    dispatch(handleSetPatientRegistrationPayload(pdfPayload));
  };

  return (
    <div>
      <div className="w-full">
        <div className="flex justify-between space-x-4 m-2 mb-5">
          <div>
            <h3 className="font-bold text-base">Chronic Conditions</h3>
          </div>
          <div>
            <button
              onClick={handleModalOpen}
              className="w-28 h-9 px-2 flex text-white items-center gap-2 border border-[#3B98B9] rounded-md bg-brand-primaryColor "
            >
              <span className="">+ Add New</span>
            </button>
          </div>
        </div>
      </div>
      <>
        <div
          className={`${isLoading === false && currLocalMappedChronics?.length === 0
              ? "w-full flex justify-center items-center"
              : "overflow-y-scroll scrollWidth"
            }`}
        >
          {isLoading && currLocalMappedChronics?.length === 0 ? (
            <div className="flex items-center justify-center mt-[10%]">
              <Flex align="center" gap="middle">
                <Spin size="large" tip="Loading" />
              </Flex>
            </div>
          ) : currLocalMappedChronics?.length === 0 ? (
            <div className="flex flex-col items-center justify-center">
              <img
                src={nodatafound}
                alt="nodatafound"
                className="h-min w-min"
              />
              <p className="font-medium text-xl">No data found!!</p>
            </div>
          ) : (
            <div>
              <ProgInsuranceCCTable
                data={currLocalMappedChronics}
                totalCount={currLocalMappedChronics?.length}
              />
            </div>
          )}
        </div>
      </>

      <div>
        <AddInsuranceDetails
          currPageView={currPageView}
          handleCancel={handleCancel}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
          currLocalMappedChronics={currLocalMappedChronics}
        >
          <div>
            <h3 className="font-bold text-base my-3">Consent Form</h3>
            <h4 className="font-bold text-base my-3">Attachment Details</h4>
            <div>
              File Supported:{" "}
              <span className="text-blue-500"> PDF - Up to 2MB</span>
            </div>

            <div className="grid md:grid-cols-4 grid-cols-2 gap-1">
              <div className="my-3 items-center bg-[#F4FEFF] rounded-md p-2 border">
                <label>
                  Physician Order <span style={{ color: "#FF000F" }}>*</span>
                </label>

                <div className="flex justify-between items-center mt-1">
                  <div>
                    {ConsentFour && (
                      <div className="flex items-center gap-1">
                        <EyeOutlined
                          className="cursor-pointer px-1 text-lg"
                          onClick={() => showPdf("PHYSICIAN_ORDER")}
                        />
                        <img
                          className="cursor-pointer w-4 h-4"
                          onClick={() => handleDelete("PHYSICIAN_ORDER")}
                          src={deleteHoverIcon}
                          alt="delete"
                        />
                      </div>
                    )}
                  </div>

                  <label className="cursor-pointer viewbtn">
                    <input
                      type="file"
                      onChange={(e) =>
                        changeHandler(e.target.files[0], "PHYSICIAN_ORDER")
                      }
                      className="hidden"
                    />
                    <span className="rounded-sm text-lg bg-brand-primaryColor">
                      <UploadOutlined className="text-white p-4 font-bold" />
                    </span>
                  </label>
                </div>
              </div>

              <div className="my-3 items-center bg-[#F4FEFF] rounded-md p-2 border">
                <label>
                  On Device Responsibility{" "}
                  <span style={{ color: "#FF000F" }}>*</span>
                </label>

                <div className="flex justify-between items-center mt-1">
                  <div>
                    {consentThree && (
                      <div className="flex items-center gap-1">
                        <EyeOutlined
                          className="cursor-pointer px-1 text-lg"
                          onClick={() => showPdf("DEVICE_RESP")}
                        />
                        <img
                          className="cursor-pointer w-4 h-4"
                          onClick={() => handleDelete("DEVICE_RESP")}
                          src={deleteHoverIcon}
                          alt="delete"
                        />
                      </div>
                    )}
                  </div>

                  <label className="cursor-pointer viewbtn">
                    <input
                      type="file"
                      accept="application/pdf"
                      onChange={(e) =>
                        changeHandler(e.target.files[0], "DEVICE_RESP")
                      }
                      className="hidden"
                    />
                    <span className="rounded-sm text-lg bg-brand-primaryColor">
                      <UploadOutlined className="text-white p-4 font-bold" />
                    </span>
                  </label>
                </div>
              </div>

              {/* To Share Patient Data */}
              <div className="my-3 items-center bg-[#F4FEFF] rounded-md p-2 border">
                <label>
                  To Share Patient Data{" "}
                  <span style={{ color: "#FF000F" }}>*</span>
                </label>

                <div className="flex justify-between items-center mt-1">
                  <div>
                    {consentTwo && (
                      <div className="flex items-center gap-1">
                        <EyeOutlined
                          className="cursor-pointer px-1 text-lg"
                          onClick={() => showPdf("PATIENT_DATA")}
                        />
                        <img
                          className="cursor-pointer w-4 h-4"
                          onClick={() => handleDelete("PATIENT_DATA")}
                          src={deleteHoverIcon}
                          alt="delete"
                        />
                      </div>
                    )}
                  </div>

                  <label className="cursor-pointer viewbtn">
                    <input
                      type="file"
                      accept="application/pdf"
                      onChange={(e) =>
                        changeHandler(e.target.files[0], "PATIENT_DATA")
                      }
                      className="hidden"
                    />
                    <span className="rounded-sm text-lg bg-brand-primaryColor">
                      <UploadOutlined className="text-white p-4 font-bold" />
                    </span>
                  </label>
                </div>
              </div>

              {/* On Program */}
              <div className="my-3 items-center bg-[#F4FEFF] rounded-md p-2 border">
                <label>
                  On Program <span style={{ color: "#FF000F" }}>*</span>
                </label>

                <div className="flex justify-between items-center mt-1">
                  <div>
                    {consentOne && (
                      <div className="flex items-center gap-1">
                        <EyeOutlined
                          className="cursor-pointer px-1 text-lg"
                          onClick={() => showPdf("PROGRAM")}
                        />
                        <img
                          className="cursor-pointer w-4 h-4"
                          onClick={() => handleDelete("PROGRAM")}
                          src={deleteHoverIcon}
                          alt="delete"
                        />
                      </div>
                    )}
                  </div>

                  <label className="cursor-pointer viewbtn">
                    <input
                      type="file"
                      accept="application/pdf"
                      onChange={(e) =>
                        changeHandler(e.target.files[0], "PROGRAM")
                      }
                      className="hidden"
                    />
                    <span className="rounded-sm text-lg bg-brand-primaryColor">
                      <UploadOutlined className="text-white p-4 font-bold" />
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </AddInsuranceDetails>
      </div>

      <Modal
        title={
          <span className="font-bold text-base">Add Chronic Condition</span>
        }
        open={isModalOpen}
        onCancel={handleModalClose}
        footer={[]}
        destroyOnClose
      >
        <AddChronicCondition
          handleModalClose={handleModalClose}
          handlSetLocalMappedChronics={handlSetLocalMappedChronics}
        />
      </Modal>

      <Modal
        title="View"
        open={pdfVisible}
        centered={true}
        footer={[]}
        onCancel={handlePdfViewClose}
        width={600}
        destroyOnClose
      >
        <embed
          src={viewDoc}
          width="100%"
          type="application/pdf"
          height="500px"
        />
      </Modal>
    </div>
  );
}

export default forwardRef(ProgramInsurance);
